import m from "../../package.json.js";
const e = {
  name: m.name
};
export {
  e as APP
};
